import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { ILenderUserList } from '../interfaces';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export const getAdminLenderUserListAsync = (lender_id: string) =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ILenderUserList>(`/orders/v5/admin/lender_users/${lender_id}`)
    .then((t) => t.data)
    .catch(axiosErrorHandler);
